module.exports = __webpack_public_path__ + "img/rule_01.abc62a5e.png";